import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';

const RecipeCard = ({ recipe }) => {
  return (
    <Link to={`/recipe/${recipe.id}`}>
      <Card className="hover:shadow-lg transition-shadow overflow-hidden">
        <div className="relative h-48 w-full">
          <img
            src={recipe.image}
            alt={recipe.name}
            className="object-cover w-full h-full"
          />
        </div>
        <CardHeader>
          <CardTitle>{recipe.name}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600">{recipe.description}</p>
          <div className="mt-4 flex items-center text-sm text-gray-500">
            <span>Prep time: {recipe.prepTime}</span>
            <span className="mx-2">•</span>
            <span>Cook time: {recipe.cookTime}</span>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};

export default RecipeCard;